<template>
    <div>
        <div class="header">
            <strong v-text="`JPB仓余额：${amount/100} 金豆`"></strong>
            <el-date-picker
                    class="date"
                    v-model="date"
                    type="datetimerange"
                    format="yyyy-MM-dd HH:mm"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    @change="dateChange"/>
        </div>
        <el-tabs
                v-model="activeName"
                class="common-el-tabs"
                type="card"
                @tab-click="$refs[activeName].getList()">
            <el-tab-pane label="投入记录" name="intoRecord">
                <comp-into-record ref="intoRecord" class="common-el-tab-flex"/>
            </el-tab-pane>
            <el-tab-pane label="战绩流水返佣记录" name="commissionRecord">
                <comp-commission-record ref="commissionRecord" class="common-el-tab-flex"/>
            </el-tab-pane>
            <el-tab-pane label="待手动返佣记录" name="waitingRebateRecord">
                <comp-waiting-rebate-record ref="waitingRebateRecord" class="common-el-tab-flex"/>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    import {mapState,mapMutations} from 'vuex'
    import compIntoRecord from './compIntoRecord'
    import compCommissionRecord from './compCommissionRecord'
    import compWaitingRebateRecord from './compWaitingRebateRecord'
    export default {
        components: {
            compIntoRecord,
            compCommissionRecord,
            compWaitingRebateRecord
        },
        data() {
            return {
                activeName: 'intoRecord',
                date: ''
            }
        },
        computed: {
            ...mapState('jpbAccount', ['amount'])
        },
        mounted(){
            this.$refs[this.activeName].getList()
        },
        methods: {
            ...mapMutations('jpbAccount', ['setStateDate']),
            dateChange(e) {
                this.setStateDate(e);
                this.$refs[this.activeName].getList()
            }
        }
    }
</script>
<style lang="scss" scoped>
    .header {
        position: relative;
        padding-bottom: 20px;
        line-height: 40px;
    }
    .date {
        position: absolute;
        z-index: 1;
        right: 30px;
        bottom: -30px;
    }
    :global(.el-pagination){
        padding-bottom: 20px;
    }
</style>